import { render, staticRenderFns } from "./StatusTableCell.vue?vue&type=template&id=fca54f22&scoped=true"
import script from "./StatusTableCell.vue?vue&type=script&lang=js"
export * from "./StatusTableCell.vue?vue&type=script&lang=js"
import style0 from "./StatusTableCell.vue?vue&type=style&index=0&id=fca54f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca54f22",
  null
  
)

export default component.exports